import Vue from 'vue'
import './cube-ui'
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
// import 'lib-flexible/flexible'
// 日期
import moment from 'moment'
Vue.prototype.$moment = moment

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(Vant)
Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios;

import FastClick from 'fastclick'
FastClick.attach(document.body)

Vue.config.ignoredElements = [
  'wx-open-launch-app',
];

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
